import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { TripDetailAction } from "stores/TripDtailsStore/TripDetailAction";
const mapStateToProps = (state) => {
    
  return {
    TripDetailDataList: state.TripDetailData.TripDetailDataList,
    isLoading:state.TripDetailData.TripDetailDataLoading.isLoading
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
getTripDetailDataAction:TripDetailAction.getTripDetailData
}, dispatch);

const TripDteailsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default TripDteailsStore;
 